export default __webpack_public_path__ + "static/media/black-down-sanjiao.75af98d1.svg";